/**
 * Created by andrey on 23.04.18.
 */

const DailyTasksWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this.showMenubar();
        this.createContent();

        this._super({
            name: "dailytaskswindow",
            title: Messages.get(cleverapps.dailyTasks.isAllTasksFinished() ? "DailyTasksWindow.finished.title" : "DailyTasksWindow.title"),
            content: this.content,
            foreground: bundles.windows.frames.window_foreground_png,
            styles: cleverapps.styles.DailyTasksWindow.window
        });

        this.tabs.activateTab("tasks");

        cleverapps.playSession.logEvent(cleverapps.EVENTS.DAILY_TASKS_OPEN_WINDOW);
    },

    getPerson: function () {
        return cleverapps.config.type === "merge" && (cleverapps.unitsLibrary.getActiveHero() || "dwarf");
    },

    showMenubar: function () {
        if (cleverapps.config.type !== "merge") {
            return;
        }

        const controls = [];
        cleverapps.dailyTasks.tasks.forEach((task) => {
            new RewardsList(task.getReward()).rewards.forEach((reward) => {
                reward.listControls().forEach((control) => {
                    if (controls.indexOf(control) === -1) {
                        controls.push(control);
                    }
                });
            });
        });
        cleverapps.focusManager.showControlsWhileFocused(controls);
    },

    onClose: function () {
        const task = cleverapps.dailyTasks.getCompleteAllTask();
        if (task && task.isFinished() && !task.collected) {
            task.givePrize();
        }
    },

    createTabs: function () {
        const create = function (TabClass) {
            const tab = new TabClass(this);
            this.content.addChild(tab);
            tab.setAlignment(tab.width / 2, tab.height / 2);
            return tab;
        }.bind(this);

        this.dailyTasksTab = create(DailyTasksTab);
        this.tabsInfo = {
            tasks: {
                content: this.dailyTasksTab,
                icon: bundles.tabs.frames.dailytasks_icon
            }
        };
    },

    createContent: function () {
        const styles = cleverapps.styles.DailyTasksWindow;

        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        this.createTabs();
        content.setContentSize2(this.dailyTasksTab.getContentSize());

        const tabs = this.tabs = new Tabs(this.tabsInfo, styles.tabs);
        content.addChild(tabs);
        tabs.setAlignment(styles.tabs);
        tabs.setVisible(Object.keys(this.tabsInfo).length > 1);
    },

    showHint: function (text) {
        if (this.minimal) {
            this.stopAction(this.minimalAction);
            this.minimal.remove();
        }

        this.minimal = new MinimalDialogue({
            delay: 0,
            text,
            rects: this.getMinimalDialogueRects()
        });
        this.addChild(this.minimal);
        this.minimal.display();

        this.minimalAction = this.runAction(new cc.Sequence(
            new cc.DelayTime(2),
            new cc.CallFunc(() => {
                this.minimal.remove();
                delete this.minimal;
            })
        ));
    },

    listBundles: function () {
        return ["dailytasks"];
    }
});

cleverapps.styles.DailyTasksWindow = {
    tabs: {
        height: 130,
        direction: cleverapps.UI.VERTICAL,
        x: { align: "left", dx: -145 },
        y: { align: "top", dy: -85 }
    },

    window: {
        padding: {
            left: 0,
            right: 0,
            top: 10,
            bottom: 10
        },

        Background: {
            padding: {
                bottom: 150
            }
        }
    }
};
